module.exports = __webpack_public_path__ + "img/refresh.f82edb9e.svg";